import { Storage } from "aws-amplify";
import moment from "moment";
import config from "../../config";



export async function uploadImagePDFFile(file,info,dir,homeworkId) {
  //console.log("info in stiorage service", file, info);
  const maskedName = file.name.replace(
    /[`\s~!@#$%^&*()_|+\-=?;:'",<>\\{\\}\\[\]\\\\/]/gi,
    ""
  );
  //console.log(homeworkId);
  const bucket = config.s3HomeworkBucket
  const fileType = maskedName.split('.').pop();
  //console.log(maskedName);
  const userName = info.name.split(" ").join('_');
  const fileName = `${dir}/${homeworkId}/${userName}_${info.rollNumber}.${fileType}`;
  const key = `${fileName}`;
  //console.log("key", fileName);
  try {
    const res = await Storage.put(key, file, {
      bucket: bucket,
      region: config.awsRegion,
      level : 'public',
      customPrefix: {
        "public": ""
      }
    })
    return { name:maskedName,  bucket, ...res};
  } catch (err) {
    console.log(`storage error : ${err}`);
    throw err;
  }
}

export async function uploadCsvFile(blob, dir,testId, name, isPractice) {
  const bucket = 'private-app-videos';
  let fileName = `${dir}/${testId}/${moment().format("YYYY-MM-DD")}/${name}.csv`;
  if(isPractice){
    fileName = `${dir}/${testId}/${moment().format("YYYY-MM-DD")}/${name}_practice.csv`;
  }
  const key = `${fileName}`;
  try {
    return await Storage.put(key, blob, {
      bucket: bucket,
      region: 'us-east-1',
      customPrefix: {
        "public": ""
      },
      level: 'public', 
      contentType: 'text/csv'
    });
  } catch (err) {
    console.log(`storage error : ${err}`);
    throw err;
  }
}

export async function uploadJsonFile(blob, dir,userId, logName,rollnumber) {
  const bucket = 'private-app-videos';
  const name = `${rollnumber}-${logName}-${new Date().toISOString()}.json`
  const fileName = `${dir}/${userId}/${moment().format("YYYY-MM-DD")}/${name}`;
  const key = `${fileName}`;
  try {
    return await Storage.put(key, blob, {
      bucket: bucket,
      region: 'us-east-1',
      customPrefix: {
        "public": ""
      },
      level: 'public', 
      contentType: 'application/json'
    });
  } catch (err) {
    console.log(`storage error : ${err}`);
    throw err;
  }
}